<template>
  <v-app
    :class="[
      this.isMobile ? 'mobile' : '',
      this.isLandscape ? 'landscape' : '',
      'app-container',
    ]"
  >
    <div class="rotate-portrait">
      <v-icon color="blue" width="100%" height="100%"
        >mdi-phone-rotate-portrait</v-icon
      >
      <span class="please-rotate"
        >Please rotate your device to portrait mode!</span
      >
    </div>
    <Main />
  </v-app>
</template>

<script>
import Main from "./components/Main";

export default {
  name: "App",

  components: {
    Main,
  },

  data: () => ({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  }),
  mounted: function () {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });

    if (this.isMobile) {
      this.$store.commit("setSidePanelOpen", false);
    }

    if(this.$store.getters.isEmbedded){
      document.body.className += 'embedded';
    }

    this.$store.commit("initQueryObj");

    if (this.$gtag) {
      this.$gtag.event("loaded", { method: "Google" });
    }
  },
  computed: {
    isMobile: {
      get: function () {
        return this.$store.getters.isMobile;
      },
    },
    isLandscape: {
      get: function () {
        return this.windowHeight < this.windowWidth;
      },
    },
  },
};
</script>
<style>

@media print {
  #print-container {
    pointer-events: none !important;
  }
  #print-container .title button {
    display: none;
  }

  .title button {
    display: none;
  }
  
  #print-container .title.district-state {
    padding-left: 0px;
  }

  #print-container .v-tabs {
    display: none;
  }
}
:root {
  --charcoal: #264653ff;
  --persian-green: #2a9d8fff;
  --orange-yellow-crayola: #e9c46aff;
  --sandy-brown: #f4a261ff;
  --burnt-sienna: #e76f51ff;

  --cg-blue: #0081a7ff;
  --verdigris: #00afb9ff;
  --light-yellow: #fdfcdcff;
  --peach-puff: #fed9b7ff;
  --light-peach-puff: #fff4e9;
  --tan: #eebe8f;
  --bittersweet: #f07167ff;

  --imperial-red: #ec0021;
  --honeydew: rgb(232, 242, 255);
  /* --honeydew: #ffffffeb; */
  --powder-blue: rgb(192, 215, 228);
  --celadon-blue: rgb(146, 188, 214);
  --prussian-blue: #1d3557ff;

  /* --cg-blue: #0081a7ff;
--verdigris: #00afb9ff;
--light-yellow: #fdfcdcff;
--peach-puff: #fed9b7ff;
--bittersweet: #f07167ff; */

  /* CSS HEX  */
  /* --color-light: #e63946ff;
--dark: #302b27ff;
--light: #f7f7ffff;
--color-mute: #457b9dff;
--color-dark: #191d32ff; */
}

.v-application {
  overflow: hidden;
}

html {
  overflow: hidden;
}

.rotate-portrait {
  display: none;
}

.rotate-portrait .v-icon.v-icon {
  font-size: 10em;
  width: 100%;
  height: 100%;
}

.please-rotate {
  color: black;
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  bottom: 20%;
  font-size: 1.5em;
}
.v-icon.v-icon {
  color: var(--celadon-blue);
}

.mapboxgl-ctrl-bottom-left {
  z-index: auto;
}
</style>

<!--ALL MOBILE CSS-->
<style>
.mobile.landscape .rotate-portrait {
  display: block;
  position: fixed;
  z-index: 4;
  background: white;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.mobile .legend {
  bottom: 0;
  right: 0;
  left: 0;
  overflow: scroll;
  /* height: 100px; */
  font-size: 0.85em;
  line-height: 1.25em;
}

.mobile .legend.collapse {
  bottom: 70px;
  right: auto;
  left: 10px;
  overflow: scroll;
  /* height: 100px; */
  font-size: 0.85em;
  line-height: 1.25em;
}

.mobile .legend button.close {
  bottom: auto;
  top: 5px;
}

.mobile .mapboxgl-ctrl-bottom-right {
  bottom: 60px;
}

.mobile .side-menu {
  z-index: 2;
  max-width: none;
  right: 0;
  width: auto;
  animation-name: show-side-anim-mobile;
  animation-duration: 0.5s;
}

.mobile .side-menu .expand-icon {
  display: none;
}

.mobile .main-container .title-link .title {
  right: 0;
  left: 10px;
  position: absolute;
  padding-top: 8px;
}

.mobile .main-container .subtitle {
  font-size: 0.6em;
  text-overflow: initial;
  white-space: break-spaces;
  width: 77%;
  line-height: 1.1em;
}

.mobile header.v-toolbar .form-group .v-input {
  display: inline-block;
  caret-color: black;
  position: absolute;
  right: 2%;
  top: 13px;
  max-width: 36%;
  margin-top: 0 !important;
  background: rgba(255, 255, 255, 0);
}

.mobile header.v-toolbar .form-group .v-input.v-input--is-focused {
  max-width: none;
  background: white;
}

.mobile header .form-group .mdi-magnify {
  display: none;
}

.mobile .expand-icon[data-v-5fefa394] {
  position: relative;
  /* bottom: 5px; */
  top: 66px;
  text-align: right;
  right: 12px;
}

.mobile .tap-more {
  background: #0000007a;
  /* opacity: .5; */
  color: white;
  /* vertical-align: middle; */
  position: absolute;
  left: 0;
  right: 0;
  top: 164px;
  height: 2em;
  text-align: center;
  /* z-index: 2; */
  display: block;
}

/* .mobile .tap-more.bottom{
    position: inherit;
    left: auto;
    right: auto;
    top: 108px;
    bottom: auto;
} */

.mobile .district-data-container {
  top: 132px;
}

.mobile .zoom.zoom-btn {
  transform: scale(0.75);
  margin: 0;
  margin-top: -10px;
}

.mobile .selected-district-container {
  padding-top: 64px;
}
.mobile .hideSide {
  height: 100px;
  animation-name: hide-side-anim-mobile;
  animation-duration: 0.5s;
  overflow: hidden;
}

.mobile .hideSide.districtSelected {
  height: 224px;
}

.mobile .side-menu.hideSide .selected-district-data-item,
.mobile .side-menu.hideSide .clean-side-bg {
  display: none;
}

@keyframes show-side-anim-mobile {
  from {
    height: 224px;
    opacity: 1;
  }
  to {
    height: 100%;
    opacity: 1;
  }
}

@keyframes hide-side-anim-mobile {
  from {
    height: 100%;
    opacity: 1;
  }
  to {
    height: 224px;
    opacity: 1;
  }
}

.mobile .title.district-state {
  max-width: 100%;
}

.embedded .side-menu{
  max-width: 300px;
}

.embedded .district-data-container{
 max-width: 300px;
}

.embedded .title-link{
  max-width: 285px;
}

.embedded .title-link .subtitle{
  font-size: 44%;
}

.embedded .top-toolbar-content, .embedded .v-toolbar__content{
  height: 64px !important;
}
.embedded .v-slide-group__prev.v-slide-group__prev--disabled{
  display: none !important;
}

.embedded .v-slide-group__content{
  width: 100%;
}

.embedded .v-tab{
  padding: 0px;
}
</style>
